import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=2e9dd96b"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPostImage: require('/home/forge/farescraper.com/components/BlogPostImage.vue').default,BlogAuthorSign: require('/home/forge/farescraper.com/components/BlogAuthorSign.vue').default})
